import * as go from 'gojs';
import { TEXT_NODE_TEXT_BLOCK } from '../common/config/common-part-names';
import { CustomTextEditor } from '../common/parts/text-editor';
import {
  angleBinding,
  editableBinding,
  fillBinding,
  locationBinding,
  lockedBindings,
  shadowBindings,
  sizeBinding,
  textAlignmentBinding,
  textFontBinding,
  zOrderBindings,
} from '../common/utils/bindings';
import { realPorts, virtualPorts } from './../common/parts/port';
import { textMargin } from './config/config';
import { STICKY_NODE_MAIN_SHAPE } from './config/part-names';
import { textBinding, textBlockSizeBinding, textColorBinding } from './utils/bindings';
import { editOnDoubleClick } from './utils/events';

const $ = go.GraphObject.make;

const movable = true;
const resizable = true;
const rotatable = true;

const shape = () =>
  $(
    go.Shape,
    {
      figure: 'RoundedRectangle',
      name: STICKY_NODE_MAIN_SHAPE,
      stroke: null,
    },
    sizeBinding(),
    fillBinding(),
  );

const textBlock = () =>
  $(
    go.TextBlock,
    {
      name: TEXT_NODE_TEXT_BLOCK,
      editable: true,
      isMultiline: true,
      alignment: new go.Spot(0, 0, textMargin, textMargin),
      alignmentFocus: go.Spot.TopLeft,
      overflow: go.TextBlock.OverflowEllipsis,
      textEditor: $(CustomTextEditor),
      stretch: go.GraphObject.Horizontal,
    },
    textBinding(),
    textAlignmentBinding(),
    textFontBinding(),
    editableBinding(),
    textBlockSizeBinding(),
    textColorBinding(),
  );

export const stickyNodeTemplate = () =>
  $(
    go.Node,
    go.Node.Spot,
    {
      isShadowed: true,
      resizeObjectName: STICKY_NODE_MAIN_SHAPE,
      selectionObjectName: STICKY_NODE_MAIN_SHAPE,
      locationObjectName: STICKY_NODE_MAIN_SHAPE,
      isLayoutPositioned: false,
      toolTip: null,
      rotationSpot: go.Spot.Center,
      locationSpot: go.Spot.Center,
      movable,
      resizable,
      rotatable,
      doubleClick: editOnDoubleClick,
    },
    shape(),
    textBlock(),
    locationBinding(),
    angleBinding(),
    ...lockedBindings({ movable, resizable, rotatable }),
    ...shadowBindings(),
    ...zOrderBindings(),
    ...virtualPorts(),
    ...realPorts(),
  );
